"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GeneralQuestion = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const styled_components_1 = __importDefault(require("styled-components"));
const react_i18next_1 = require("react-i18next");
const IntakeTableHeader_1 = __importDefault(require("./IntakeTableHeader"));
const card_1 = require("../../molecules/card");
const card_row_divided_1 = require("../../atoms/card-row-divided");
const typography_1 = require("../../shared/typography");
const hooks_1 = require("../../shared/hooks");
const fixAnswer = (answer) => answer ? answer.replace(/<br>/g, " ") : "";
const renderPlanPurposeQuestion = ({ question, answer }) => ((0, jsx_runtime_1.jsx)(PlanQuestion, { children: (0, jsx_runtime_1.jsx)(card_row_divided_1.CardRowDivided, { left: (0, jsx_runtime_1.jsx)(typography_1.P, { children: question }, void 0), right: (0, jsx_runtime_1.jsx)(typography_1.H4, { children: fixAnswer(answer) }, void 0) }, question.substr(0, 4)) }, void 0));
const renderGeneralQuestion = (isMobile, explanation) => ({ category, question, answer, comment }) => ((0, jsx_runtime_1.jsxs)(exports.GeneralQuestion, { children: [(0, jsx_runtime_1.jsxs)(typography_1.P, { children: ["[", (0, jsx_runtime_1.jsx)("span", { children: category.toLowerCase() }, void 0), "]"] }, void 0), (0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsx)(typography_1.P, { children: question }, void 0), isMobile && comment && ((0, jsx_runtime_1.jsxs)(typography_1.P, { children: [(0, jsx_runtime_1.jsxs)("span", { children: [explanation, "\u00A0"] }, void 0), fixAnswer(comment)] }, void 0))] }, void 0), (0, jsx_runtime_1.jsx)(typography_1.H4, { children: answer }, void 0), !isMobile && (0, jsx_runtime_1.jsx)(typography_1.H4, { children: fixAnswer(comment || "") }, void 0)] }, question));
exports.default = (0, react_1.memo)(({ translations, intake, tableName }) => {
    const { isMobile } = (0, hooks_1.useRWD)();
    const { t } = (0, react_i18next_1.useTranslation)();
    return ((0, jsx_runtime_1.jsx)(card_1.CollapsableCard, { header: (0, jsx_runtime_1.jsx)(IntakeTableHeader_1.default, { title: tableName }, void 0), children: (0, jsx_runtime_1.jsx)(Wrapper, { children: [
                intake.xQuestions.map(renderPlanPurposeQuestion),
                (0, jsx_runtime_1.jsx)(typography_1.H3, { children: translations.questions.otherQuestions }, "h3"),
                intake.questions.map(renderGeneralQuestion(isMobile, t("intake.explanation")))
            ] }, void 0) }, void 0));
});
const Wrapper = styled_components_1.default.div `
  p,
  h4 {
    margin-bottom: 0;
  }

  h3 {
    padding: ${({ theme }) => `${theme.spacings.m} 0`};
  }

  & > div:not(:last-of-type) {
    border-bottom: 1px solid
      ${({ theme }) => theme.colors.silverLighten40};
  }
`;
exports.GeneralQuestion = styled_components_1.default.div `
  align-items: flex-start;
  display: flex;
  justify-content: space-between;
  padding: ${({ theme }) => `${theme.spacings.xs} 0`};
  line-height: 1.25em;

  & > h4 {
    flex: 1;
    hyphens: auto;
    line-height: 1rem;
    overflow-wrap: break-word;
    word-wrap: break-word;
    word-break: break-word;
  }

  & > p:first-of-type {
    min-width: 90px;
    flex: 1;
  }

  & > p:first-of-type span {
    text-transform: capitalize;
  }

  & > div {
    flex: 3;
  }

  & > div p {
    padding-right: ${({ theme }) => theme.spacings.xxs};
    word-break: break-word;
  }

  & > div span {
    display: inline-block;
    font-weight: 600;
    line-height: 1.5rem;
    margin-top: ${({ theme }) => theme.spacings.xs};
    text-transform: capitalize;
  }
`;
const PlanQuestion = styled_components_1.default.div `
  & > div > div {
    align-self: flex-start;
  }

  & > div > div:first-of-type {
    flex: 2;

    p {
      padding-right: ${({ theme }) => theme.spacings.xl};
    }
  }

  & > div > div:last-of-type {
    flex: 1;
    padding-left: 0;
  }

  & h4 {
    line-height: 1rem;
  }

  @media (max-width: ${({ theme }) => theme.utils.breakpoints.mobile}) {
    & > div > div:first-of-type {
      flex: 1;
    }

    & > div > div:last-of-type {
      flex: 1;
    }
  }
`;
//# sourceMappingURL=CollapseIntakeBuildingPlan.js.map